import { styled } from '@mui/material/styles';
import { getDrugTestThemeTokens } from '../themeTokens';
import type { ResolutionBadgeVariant, SourceBadgeVariant } from './types';

export const SelectorRow = styled('div')({
  display: 'flex',
  gap: 8,
  flexWrap: 'wrap',
  marginBottom: 16,
});

export const ReportCardButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected?: boolean }>(({ theme, selected }) => {
  const t = getDrugTestThemeTokens(theme);
  return {
    appearance: 'none',
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 4,
    padding: '8px 14px',
    borderRadius: 8,
    border: selected ? `1px solid ${t.violet}` : `1px solid ${t.border}`,
    background: selected ? t.violetLight : t.surface,
    color: selected ? t.violetText : t.text,
    fontWeight: selected ? 600 : 400,
    fontSize: 13,
    fontFamily: 'inherit',
    cursor: 'pointer',
    textAlign: 'left',
    '&:hover': {
      borderColor: t.violet,
    },
    '&:focus-visible': {
      outline: `2px solid ${t.violet}`,
      outlineOffset: 2,
    },
  };
});

export const CardMain = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  flexWrap: 'wrap',
});

export const CardMeta = styled('span')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  width: '100%',
  minWidth: 0,
});

export const CardNote = styled('span')(({ theme }) => ({
  fontSize: 11,
  fontWeight: 500,
  color: getDrugTestThemeTokens(theme).textMuted,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const SourceBadge = styled('span', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: SourceBadgeVariant }>(({ theme, variant }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  padding: '1px 6px',
  borderRadius: 4,
  fontSize: 9,
  fontWeight: 700,
  letterSpacing: '0.03em',
  textTransform: 'uppercase',
  border: '1px solid transparent',
  ...getDrugTestThemeTokens(theme).sourceBadge[variant],
}));

export const ResolutionBadge = styled('span', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: ResolutionBadgeVariant }>(({ theme, variant }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  flexShrink: 0,
  marginLeft: 'auto',
  padding: '1px 6px',
  borderRadius: 4,
  fontSize: 11.5,
  fontWeight: 500,
  letterSpacing: '0.03em',
  textTransform: 'lowercase',
  border: '1px solid transparent',
  ...getDrugTestThemeTokens(theme).resolutionBadge[variant],
}));
